<template>
  <div :class="{ 'bg-white': !nightMode, 'bg-dark': nightMode }" class="p-st">

    <div class="container py-4">
      <div class="text-center" data-aos="fade" data-aos-once="true" data-aos-duration="1000">
        <span class="title text-center" :class="{ pgray: !nightMode, 'text-light': nightMode }">Contact.</span>
      </div>
      <hr width="50%" :class="{ pgray: !nightMode, 'bg-secondary': nightMode }" />
      <br />
      <div class="text-center">
        <div class="mb-3" data-aos="fade-up" data-aos-once="true" data-aos-duration="1000">
          <input type="text" name="user_name" v-model="name" placeholder="name" class="pinput" :class="{
            pgray: !nightMode,
            'pgray-dark': nightMode,
            'text-light': nightMode,
          }" style="transition-delay: 0.2s" />
        </div>

        <div class="my-3" data-aos="fade-up" data-aos-once="true" data-aos-duration="1000">
          <input type="email" name="user_email" v-model="email" placeholder="email" class="pinput" :class="{
            pgray: !nightMode,
            'pgray-dark': nightMode,
            'text-light': nightMode,
          }" style="transition-delay: 0.4s" />
        </div>

        <div class="my-3" data-aos="fade-up" data-aos-once="true" data-aos-duration="1000">
          <textarea name="message" v-model="text" placeholder="message" class="pinput" rows="4" :class="{
            pgray: !nightMode,
            'pgray-dark': nightMode,
            'text-light': nightMode,
          }" style="transition-delay: 0.6s"></textarea>
        </div>

        <button @click.prevent="sendEmail" class="mt-1 btn mb-3" :disabled="isSending" data-aos="fade"
          data-aos-once="true" data-aos-duration="1000" data-aos-offset="50">
          {{ isSending ? "Sending..." : "Send" }}
        </button>
      </div>

      <Snackbar :showSnackbar="showSnackbar" @close="closeSnackbar" :snackbarMessage="snackbarMessage"
        :snackbarColor="snackbarColor" :inline="true" />
    </div>
  </div>
</template>

<script>
import config from "../../config";
import emailjs from "emailjs-com";

import Snackbar from "./helpers/Snackbar";

export default {
  name: "Contact",
  components: {
    Snackbar,
  },
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      email: "",
      name: "",
      text: "",
      isSending: false,
      showSnackbar: false,
      snackbarMessage: "",
      snackbarColor: "",
    };
  },
  created() {
    try {
      if (config?.emailjs?.userID) {
        emailjs.init(config.emailjs.userID);
      }
    } catch (e) {
      // If init fails, send() will surface the real error.
      console.error("EmailJS init error:", e);
    }
  },
  methods: {
    closeSnackbar(val) {
      if (!val) {
        setTimeout(() => {
          this.showSnackbar = val;
        }, 1000);
      }
    },
    sendEmail() {
      if (this.isSending) return;
      if (!this.email || !this.name || !this.text) {
        this.showSnackbar = true;
        this.snackbarMessage = "Please fill all the fields";
        this.snackbarColor = "#64808E";
      } else {
        this.isSending = true;
        var obj = {
          user_name: this.name,
          user_email: this.email,
          reply_to: this.email,
          from_name: this.name,
          message: this.text,
          message_html: this.text,
          to_name: "Julio Notodiprodyo",
        };

        emailjs.send(
          config.emailjs.serviceID,
          config.emailjs.templateID,
          obj,
          config.emailjs.userID
        )
          .then(() => {
            this.showSnackbar = true;
            this.snackbarMessage = "Thanks! Message received.";
            this.snackbarColor = "#1aa260";

            this.email = "";
            this.text = "";
            this.name = "";
          })
          .catch((error) => {
            this.showSnackbar = true;
            const details =
              (error && (error.text || error.message)) ||
              (typeof error === "string" ? error : "");
            this.snackbarMessage = details
              ? `Oops! Something went wrong. (${details})`
              : "Oops! Something went wrong.";
            this.snackbarColor = "#c0392b";
            console.error("Error sending email:", error);
          })
          .finally(() => {
            this.isSending = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 30px;
  font-weight: 500;
}

.title1 {
  font-size: 24px;
  font-weight: 400;
}

.title2 {
  font-size: 20px;
  font-weight: 400;
}

.title3 {
  font-size: 16px;
  font-weight: 400;
}

.pinput {
  font-size: 18px;
  outline: none;
  border: none;
  border-radius: 7px;
  padding: 10px;
  width: 50%;
  transition: all 1s;
  background-color: #b3b3cc;
}

.btn {
  border-color: #759CC9;
  color: #759CC9;
  width: 50%;
}

.btn:hover {
  background-color: #759CC9;
  border-color: #759CC9;
  color: white;
}

.btn:focus {
  background-color: #759CC9;
  border-color: #759CC9;
  color: white;
}

.pgray-dark {
  background-color: #3c4148 !important;
}

@media screen and (max-width: 1000px) {
  .pinput {
    width: 90%;
  }

  .pinput {
    width: 90%;
  }

  .btn {
    width: 90%;
  }
}
</style>
